import React from 'react'
import CodeManager from '../../Components/CodeManager'

export default function Codes() {
  return <CodeManager />
}